export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  FileUpload: { input: any; output: any; }
}

export interface Company {
  __typename?: 'Company';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  unrealVersion: Scalars['String']['output'];
}

export interface Country {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface CreateDownloadInput {
  renderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  spinnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
}

export interface CreateDownloadPayload {
  __typename?: 'CreateDownloadPayload';
  download?: Maybe<Download>;
}

export interface CreatePasswordResetRequestInput {
  email: Scalars['String']['input'];
  resetLink: Scalars['String']['input'];
}

export interface CreatePasswordResetRequestPayload {
  __typename?: 'CreatePasswordResetRequestPayload';
  success: Scalars['Boolean']['output'];
}

export interface Download {
  __typename?: 'Download';
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
}

export interface GenerateTokenInput {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}

export interface Mutation {
  __typename?: 'Mutation';
  createDownload?: Maybe<CreateDownloadPayload>;
  createPasswordResetRequest?: Maybe<CreatePasswordResetRequestPayload>;
  generateToken?: Maybe<TokensPayload>;
  refreshToken?: Maybe<TokensPayload>;
  resetPassword?: Maybe<TokensPayload>;
  updateMe?: Maybe<UpdateMePayload>;
  updatePassword?: Maybe<UpdatePasswordPayload>;
}


export interface MutationCreateDownloadArgs {
  input: CreateDownloadInput;
}


export interface MutationCreatePasswordResetRequestArgs {
  input: CreatePasswordResetRequestInput;
}


export interface MutationGenerateTokenArgs {
  input: GenerateTokenInput;
}


export interface MutationRefreshTokenArgs {
  input: RefreshTokenInput;
}


export interface MutationResetPasswordArgs {
  input: ResetPasswordInput;
}


export interface MutationUpdateMeArgs {
  input: UpdateMeInput;
}


export interface MutationUpdatePasswordArgs {
  input: UpdatePasswordInput;
}

export interface Query {
  __typename?: 'Query';
  countries?: Maybe<Array<Maybe<Country>>>;
  me?: Maybe<User>;
  status: Scalars['String']['output'];
  timezones?: Maybe<Array<Maybe<Timezone>>>;
  token?: Maybe<Scalars['String']['output']>;
}

export interface RefreshTokenInput {
  refreshToken: Scalars['String']['input'];
}

export interface ResetPasswordInput {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}

export interface Timezone {
  __typename?: 'Timezone';
  id: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface TokensPayload {
  __typename?: 'TokensPayload';
  refreshToken?: Maybe<Scalars['String']['output']>;
  refreshTokenExpiration?: Maybe<Scalars['Int']['output']>;
  token: Scalars['String']['output'];
}

export interface UpdateMeInput {
  avatar?: InputMaybe<Scalars['FileUpload']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timezoneId?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateMePayload {
  __typename?: 'UpdateMePayload';
  me?: Maybe<User>;
}

export interface UpdatePasswordInput {
  newPassword: Scalars['String']['input'];
  newPasswordRepeat: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
}

export interface UpdatePasswordPayload {
  __typename?: 'UpdatePasswordPayload';
  me?: Maybe<User>;
}

export interface User {
  __typename?: 'User';
  avatarPath?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  country?: Maybe<Country>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Maybe<UserRolesEnum>>>;
  settings: UserSettings;
  state?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Timezone>;
}

export enum UserRolesEnum {
  RoleCompanyAdmin = 'ROLE_COMPANY_ADMIN',
  RoleCompanyUser = 'ROLE_COMPANY_USER',
  RoleSuperAdmin = 'ROLE_SUPER_ADMIN'
}

export interface UserSettings {
  __typename?: 'UserSettings';
  allow_add_files: Scalars['Boolean']['output'];
  allow_copy_asset: Scalars['Boolean']['output'];
  allow_delete_asset: Scalars['Boolean']['output'];
  allow_delete_render: Scalars['Boolean']['output'];
  allow_delete_spinner: Scalars['Boolean']['output'];
  allow_embed: Scalars['Boolean']['output'];
  allow_lighting_presets: Scalars['Boolean']['output'];
  allow_manage_materials: Scalars['Boolean']['output'];
  allow_render_360: Scalars['Boolean']['output'];
  allow_render_jpg: Scalars['Boolean']['output'];
  allow_render_png: Scalars['Boolean']['output'];
  allow_render_tiff: Scalars['Boolean']['output'];
}
